import { POSITION_SLOT_STATUS } from '../constants';
import { PositionSlotListItem } from '../types';

const DEFAULT_POSITION_SLOT_SORT = {
  specialization: 'ASC',
  technology: 'ASC',
} as const;

export const prioritizePendingPositionSlots = (positionSlots: PositionSlotListItem[]) => {
  const pendingPositionSlots = positionSlots.filter(
    positionSlot => positionSlot.status === POSITION_SLOT_STATUS.PENDING,
  );
  const remainingPositionSlots = positionSlots.filter(
    positionSlot => positionSlot.status !== POSITION_SLOT_STATUS.PENDING,
  );

  return [...pendingPositionSlots, ...remainingPositionSlots];
};

export const getPositionSlotSort = (sort?: Dictionary<string>) => {
  if (!sort || Object.keys(sort).length === 0) {
    return { ...DEFAULT_POSITION_SLOT_SORT };
  }

  if (sort.specialization && !sort.technology) {
    return {
      ...sort,
      technology: 'ASC',
    };
  }

  return sort;
};
